export const heroBusinessConsultingText = {
  en: {
    small: "",
    main: " Business Consulting",
  },
  vi: {
    small: "",
    main: "Tư vấn Doanh nghiệp ",
  },
};

export const quoteBusinessConsultingText = {
  en: {
    desc: `Whether you’re looking to improve workflow, reduce costs, or unlock new growth opportunities, our SME consulting service provides the strategies, tools, and guidance needed to turn business challenges into measurable success.`,
    cta: "Contact us now",
  },
  vi: {
    desc: `Dù bạn muốn tối ưu quy trình vận hành, giảm chi phí hay tìm kiếm cơ hội tăng trưởng mới, dịch vụ tư vấn doanh nghiệp SMEs của chúng tôi sẽ cung cấp chiến lược, công cụ và giải pháp thực tế để biến thách thức thành kết quả kinh doanh rõ ràng.`,
    cta: "Liên hệ ngay",
  },
};

export const BusinessConsultingData = {
  en: [
    {
      id: 1,
      title: "Streamline Your Operations. Boost Your Profitability.",
      description:
        "Running a small or medium-sized business comes with unique challenges — limited resources, rising costs, and constant pressure to grow. Our Business Consulting for SMEs service is designed to help you overcome these challenges with practical, results-driven strategies that improve performance and drive sustainable business growth.",
      list: [],
    },
    {
      id: 2,
      title: "What We Do",
      description: "",
      list: [
        "Optimize Your Operations: Identify bottlenecks and inefficiencies to improve workflow, productivity, and business performance.",
        "Increase Profitability: Discover hidden profit leaks and implement strategies that strengthen your bottom line.",
        "Strategic Growth Planning: Develop tailored action plans that support sustainable business expansion.",
        "Hands-On Support: We work alongside you to implement practical solutions that deliver measurable results.",
      ],
    },
  ],

  vi: [
    {
      id: 1,
      title:
        "Tối ưu vận hành. Gia tăng lợi nhuận. Phát triển doanh nghiệp bền vững.",
      description:
        "Điều hành một doanh nghiệp vừa và nhỏ luôn đi kèm nhiều thách thức như nguồn lực hạn chế, chi phí gia tăng và áp lực phát triển liên tục. Dịch vụ Tư vấn Doanh nghiệp cho SMEs của chúng tôi giúp bạn giải quyết các vấn đề này bằng những chiến lược thực tế, rõ ràng và tập trung vào kết quả.",
      list: [],
    },
    {
      id: 2,
      title: "Chúng tôi giúp bạn như thế nào",
      description: "",
      list: [
        "Tối ưu vận hành doanh nghiệp: Xác định các điểm nghẽn và cải thiện quy trình để doanh nghiệp hoạt động hiệu quả hơn.",
        "Gia tăng lợi nhuận: Tìm ra các chi phí thất thoát và áp dụng chiến lược nâng cao hiệu quả kinh doanh.",
        "Lập kế hoạch tăng trưởng chiến lược: Xây dựng lộ trình phát triển phù hợp với mục tiêu và quy mô doanh nghiệp.",
        "Đồng hành thực tế: Không chỉ tư vấn, chúng tôi làm việc cùng bạn để tạo ra kết quả thực tế và đo lường được.",
      ],
    },
  ],
};

export const businessConsultingCTA = {
  en: {
    text: "Get started today and transform your business into a more efficient, profitable, and high-performing operation.",
    button1: "Contact us now →",
  },
  vi: {
    text: "Đồng hành cùng chúng tôi ngay hôm nay để xây dựng doanh nghiệp vận hành hiệu quả hơn, gia tăng lợi nhuận và phát triển bền vững.",
    button1: "Liên hệ ngay →",
  },
};
